import { render, staticRenderFns } from "./Postbacks.vue?vue&type=template&id=8ab26ee4"
import script from "./Postbacks.vue?vue&type=script&lang=js"
export * from "./Postbacks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports